import React from 'react';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useTranslate } from '../../context/api-context/translations/use-translate';
const weekAgo = () => new Date().getTime() - 1000 * 60 * 60 * 24 * 7;
const isLessThanWeek = (date) => new Date(date).getTime() > weekAgo();
const isNotCurrentYear = (date) => new Date().getFullYear() !== new Date(date).getFullYear();
const normalizeTime = (time) => {
    const currentDate = new Date();
    const originalDate = new Date(time);
    return originalDate.getTime() > currentDate.getTime() ? currentDate : originalDate;
};
const TimeAgo = ({ className, ...props }) => {
    const { formatRelativeTime, screenshotMode } = useConfiguration();
    const t = useTranslate();
    const time = props.time ? normalizeTime(props.time) : null;
    return time ? (React.createElement("span", { className: className, "data-hook": "time-ago" }, (() => {
        if (screenshotMode) {
            return '<time>';
        }
        if (isLessThanWeek(time)) {
            return formatRelativeTime(time);
        }
        if (isNotCurrentYear(time)) {
            return t('fullDate', { time });
        }
        return t('shortDate', { time });
    })())) : null;
};
export default TimeAgo;
//# sourceMappingURL=time-ago.js.map